import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=696ce7e8&"
import script from "./customers.vue?vue&type=script&lang=ts&"
export * from "./customers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports